import React from 'react';
import MissionsList from '../components/MissionsList';

const Missions = () => (
  <>
    <MissionsList />
  </>
);

export default Missions;
